import { useCallback } from 'react';

import { GRAPHQL_ERROR_CODES } from 'src/data/graphqlErrorCodes';
import { useGraphQLErrorHandler } from 'src/services';
import { useCustomerActions, useNotificationActions } from 'src/store';

import { useRename } from './useRename';

const ERROR_CODE_MAPPING = {
  [GRAPHQL_ERROR_CODES.customer_name_taken]:
    'This company name has already been claimed by another account',
};

export const useRenameCustomer = ({ initialName, onSubmit }) => {
  const customerActions = useCustomerActions();
  const notificationActions = useNotificationActions();
  const handleGraphQLError = useGraphQLErrorHandler({
    getErrorMessage: (errorCode) => ERROR_CODE_MAPPING[errorCode],
  });

  const handleSubmit = useCallback(
    async (name) => {
      await customerActions.renameCurrentCustomer(name);
      notificationActions.displaySuccess('Name saved');

      if (onSubmit) onSubmit();
    },
    [customerActions, onSubmit, notificationActions]
  );

  return useRename({
    initialName,
    onSubmit: handleSubmit,
    onError: handleGraphQLError,
  });
};
